// extracted by mini-css-extract-plugin
export var actionDetails = "pages-account-card-__BlockOrReplaceFlow-module___actionDetails";
export var actionSelectionSection = "pages-account-card-__BlockOrReplaceFlow-module___actionSelectionSection";
export var container = "pages-account-card-__BlockOrReplaceFlow-module___container";
export var section = "pages-account-card-__BlockOrReplaceFlow-module___section";
export var sectionHeader = "pages-account-card-__BlockOrReplaceFlow-module___sectionHeader";
export var srOnly = "pages-account-card-__BlockOrReplaceFlow-module___srOnly";